module.exports = __webpack_public_path__ + "img/99.5b913824.jpg";